import ThongTinChung from './ThongTinChung.jsx';
import DanhSachCuocThanhTra from './DanhSachCuocThanhTra.jsx';
import ThemMoiDoiTuongThanhTra from './ThemMoiDoiTuongThanhTra.jsx';
import Search from './Search.jsx';
import DialogChinhSuaCuocThanhTra from './DialogChinhSuaCuocThanhTra.jsx';
import NoiDungKienNghi from './NoiDungKienNghi.jsx';
import DoiTuongKienNghiView from './DoiTuongKienNghiView.jsx';

export {
  ThemMoiDoiTuongThanhTra,
  ThongTinChung,
  DanhSachCuocThanhTra,
  Search,
  DialogChinhSuaCuocThanhTra,
  NoiDungKienNghi,
  DoiTuongKienNghiView
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/sub-view/index.js